import intl from 'react-intl-universal';
import { logout } from '@/api/login';
import { redirectToLogin } from '@/utils/redirectToLogin';
import { message as Message } from 'antd';
import styles from '../ReceiveStatus/index.less';

const Logout: React.FC = () => {
    const logoutAction = () => {
        logout().then((res) => {
            if (res) {
                redirectToLogin();
            } else {
                Message.error(intl.get('退出登录失败，请重试'));
            }
        });
    };

    return (
        <span
            className={styles.headerBtnOut}
            onClick={logoutAction}
        >
            {intl.get('退出登录')}
        </span>
    );
};

export default Logout;
